import { useSearchParams } from 'react-router-dom';
import { PageLayout } from '@/components/layout/PageLayout';
import { CheckCircle2 } from 'lucide-react';

export function RegistrationSuccess() {
  const [searchParams] = useSearchParams();
  const scheduleId = searchParams.get('scheduleId');

  return (
    <PageLayout>
      <div className="text-center py-12 space-y-4">
        <CheckCircle2 className="h-16 w-16 text-green-500 mx-auto" />
        <h2 className="text-2xl font-bold tracking-tight">Registration Complete</h2>
        <p className="text-muted-foreground max-w-md mx-auto">
          Registration complete! Check your email for scheduling instructions.
        </p>
        {scheduleId && (
          <div className="mt-6 rounded-lg border bg-card p-4 max-w-sm mx-auto">
            <p className="text-sm text-muted-foreground">Schedule Reference</p>
            <p className="text-sm font-mono font-medium mt-1">{scheduleId}</p>
          </div>
        )}
      </div>
    </PageLayout>
  );
}
